// currency/reducer.js
import {
    FETCH_CURRENCY_REQUEST,
    FETCH_CURRENCY_SUCCESS,
    FETCH_CURRENCY_FAILURE
} from "./actions";

const initialState = {
    loading: false,
    currencies: [],
    error: null
};

export default function currencyReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_CURRENCY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_CURRENCY_SUCCESS:
            return {
                ...state,
                loading: false,
                currencies: action.payload,
                error: null
            };
        case FETCH_CURRENCY_FAILURE:
            return {
                ...state,
                loading: false,
                currencies: [],
                error: action.payload
            };
        default:
            return state;
    }
}
